if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.selectors = {
          mediaGallery: "[id^=Media-Gallery]",
          liveRegion: '[id^="GalleryStatus"]',
          viewer: '[id^="GalleryViewer"]',
          thumbnailsWrapper: ".f-product__media-thumbnails-wrapper",
          thumbnails: '[id^="GalleryThumbnails"]',
          thumbnailItems: ['[id^="GalleryThumbnailItem"]'],
          videos: [".f-video__embed"],
          models: ["product-model"],
          medias: [".f-product__media"],
          xrButton: "[data-first-xr-button]",
          sliderCounter: ".flickity-counter--current",
          toggleZoom: [".js-photoswipe--zoom"],
        };

        let touchingCarousel = false;
        let startXCoordinate;

        document.body.addEventListener(
          "touchstart",
          (e) => {
            if (e.target.closest(".flickity-slider")) {
              touchingCarousel = true;
            } else {
              touchingCarousel = false;
              return;
            }
            startXCoordinate = e.touches[0].pageX;
          },
          { passive: true }
        );

        document.body.addEventListener(
          "touchmove",
          (e) => {
            if (touchingCarousel && e.cancelable) {
              if (Math.abs(e.touches[0].pageX - startXCoordinate) > 10) {
                e.preventDefault();
              }
            }
          },
          { passive: false }
        );
      }

      connectedCallback() {
        this.init();
      }

      disconnectedCallback() {
        clearInterval(this.check);
      }

      getSelectedVariant() {
        const selectedVariant = this.querySelector(
          "[data-selected-variant]"
        )?.innerHTML;
        return !!selectedVariant ? JSON.parse(selectedVariant) : null;
      }

      init() {
        this.domNodes = queryDomNodes(this.selectors, this);
        this.mediaLayout = this.domNodes.mediaGallery.dataset.mediaLayout;
        this.onlyImage = this.dataset.onlyImage === "true";
        this.sectionId = this.dataset.sectionId;
        this.section = this.closest("product-info");
        this.enableZoom = this.dataset.enableZoom === "true";
        this.enableVariantGroupImages =
          this.dataset.enableVariantGroupImages === "true";
        this.showFeaturedMedia = this.dataset.showFeaturedMedia === "true";
        this.variantPickers = this.section.querySelector(
          "[data-variant-picker]"
        );
        this.disableDefaultVariant =
          this.variantPickers &&
          this.variantPickers.dataset.disableDefaultVariant === "true";
        this.variantData = this.getVariantData();
        const selectedVariantId =
          (this.section &&
            this.section.querySelector('input[name="id"]')?.value) ||
          this.getSelectedVariant();
        this.currentVariant = this.variantData.find(
          (variant) => variant.id === Number(selectedVariantId)
        );

        if (!this.enableVariantGroupImages || this.onlyImage) {
          setTimeout(() => {
            this.removeAttribute("data-media-loading");
          }, 100);
        }
        this.initGalleryVideos();
        if (this.mediaLayout === "carousel") {
          setTimeout(() => {
            this.domNodes.thumbnails && this.domNodes.thumbnails.initSlider();
          });
          this.initGallerySlider();
        } else {
          const initSliders = () => {
            this.domNodes.mediaGallery &&
              this.domNodes.mediaGallery.initSlider();
            this.domNodes.thumbnails && this.domNodes.thumbnails.initSlider();
            this.mediaGallery = this.domNodes.mediaGallery.slider.instance;
            this.thumbnails =
              this.domNodes.thumbnails &&
              this.domNodes.thumbnails.slider.instance;
            this.mediaGallery.on("change", this.onSlideChanged.bind(this));
            if (
              this.currentVariant &&
              this.currentVariant.featured_media &&
              !this.disableDefaultVariant &&
              !this.showFeaturedMedia
            ) {
              this.setActiveMedia(this.currentVariant.featured_media.id);
            }
          };
          if (FoxThemeSettings.isMobile) {
            initSliders();
          }
          document.addEventListener("matchMobile", initSliders);
          document.addEventListener("unmatchMobile", () => {
            this.domNodes.mediaGallery && this.domNodes.mediaGallery.destroy();
            this.domNodes.thumbnails && this.domNodes.thumbnails.destroy();
            if (
              this.currentVariant &&
              this.currentVariant.featured_media &&
              !this.disableDefaultVariant &&
              !this.showFeaturedMedia
            ) {
              this.setActiveMedia(this.currentVariant.featured_media.id);
            }
          });
          if (this.enableZoom) this.initImageZoom();
        }
        if (this.onlyImage && this.enableZoom) this.initImageZoom();

        setTimeout(() => {
          this.dispatchEvent(
            new CustomEvent("product-media:loaded", {
              bubbles: true,
              detail: {
                currentVariant: this.currentVariant,
              },
            })
          );
        }, 100);
      }

      update() {
        if (this.domNodes.mediaGallery) this.domNodes.mediaGallery.update();
        if (this.domNodes.thumbnails) this.domNodes.thumbnails.update();
      }

      initGallerySlider() {
        if (!this.domNodes.medias.length) return;
        this.selectedSlide = null;
        this.selectedMediaType = "";
        this.check = setInterval(() => {
          this.mediaGallery =
            this.domNodes.mediaGallery.slider &&
            this.domNodes.mediaGallery.slider.instance;
          this.thumbnails =
            this.domNodes.thumbnails &&
            this.domNodes.thumbnails.slider &&
            this.domNodes.thumbnails.slider.instance;

          if (this.mediaGallery && typeof this.mediaGallery == "object") {
            clearInterval(this.check);
            this.mediaGallery.on("change", this.onSlideChanged.bind(this));

            if (this.thumbnails) {
              if (this.thumbnails.cells && this.thumbnails.cells[0]) {
                this.thumbnails.select(0);
                this.handleScreenChange();
              }
            }
            if (this.enableZoom) this.initImageZoom();
            if (
              this.currentVariant &&
              this.currentVariant.featured_media &&
              !this.disableDefaultVariant &&
              !this.showFeaturedMedia
            ) {
              this.setActiveMedia(this.currentVariant.featured_media.id);
            }
          }
        }, 100);
      }

      getVariantData() {
        this.variantData =
          this.variantData ||
          JSON.parse(
            this.querySelector('[type="application/json"]').textContent
          );
        return this.variantData;
      }

      initImageZoom() {
        let dataSource = [];
        const allMedia = this.querySelectorAll(".f-product__media");
        if (allMedia) {
          allMedia.forEach((media) => {
            if (media.dataset.mediaType === "image") {
              dataSource.push({
                id: media.dataset.mediaIndex,
                src: media.dataset.src,
                width: media.dataset.pswpWidth,
                height: media.dataset.pswpHeight,
                mediaType: media.dataset.mediaType,
              });
            }
            if (media.dataset.mediaType === "model") {
              const html = `<div class="pswp__item--${
                media.dataset.mediaType
              }">${media.querySelector("product-model").outerHTML}</div>`;
              dataSource.push({
                id: media.dataset.mediaIndex,
                html: html,
                mediaType: media.dataset.mediaType,
              });
            }

            if (
              media.dataset.mediaType === "video" ||
              media.dataset.mediaType == "external_video"
            ) {
              const html = `<div class="pswp__item--${
                media.dataset.mediaType
              }">${media.querySelector("deferred-media").outerHTML}</div>`;
              dataSource.push({
                id: media.dataset.mediaIndex,
                html: html,
                mediaType: media.dataset.mediaType,
              });
            }
          });
        }

        const options = {
          dataSource: dataSource,
          pswpModule: window.FoxTheme.PhotoSwipe,
          bgOpacity: 1,
          arrowPrev: false,
          arrowNext: false,
          zoom: false,
          close: false,
          counter: false,
          preloader: false,
          // Gymshark-style: open already zoomed in (image fills the screen, pan to explore the
          // detail) instead of fit-to-screen. Pinch/scroll can zoom further.
          initialZoomLevel: "fill",
          secondaryZoomLevel: 2,
          maxZoomLevel: 4,
          // Tapping the image should zoom, NOT hide the controls (default hides the close button).
          tapAction: "zoom",
        };

        this.lightbox = new window.FoxTheme.PhotoSwipeLightbox(options);

        this.lightbox.addFilter("thumbEl", (thumbEl, data, index) => {
          const el = this.querySelector(
            '[data-media-index="' + data.id + '"] img'
          );
          if (el) {
            return el;
          }
          return thumbEl;
        });

        this.lightbox.addFilter("placeholderSrc", (placeholderSrc, slide) => {
          const el = this.querySelector(
            '[data-media-index="' + slide.data.id + '"] img'
          );
          if (el) {
            return el.src;
          }
          return placeholderSrc;
        });

        // No gallery sync needed: the lightbox opens on a single image (the one already shown
        // in the gallery), so there is nothing to sync back on close.

        this.lightbox.on("pointerDown", (e) => {
          const currSlide = this.lightbox.pswp.currSlide.data;
          if (
            currSlide.mediaType === "video" ||
            currSlide.mediaType === "model" ||
            currSlide.mediaType === "external_video"
          ) {
            e.preventDefault();
          }
        });

        this.lightbox.on("uiRegister", () => {
          /* No prev/next arrows — single-image zoom lightbox (Gymshark-style). */

          this.lightbox.pswp.ui.registerElement({
            name: "close-zoom",
            ariaLabel: "Close zoom image",
            order: 2,
            isButton: true,
            html: '<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="f-icon-svg f-icon--medium  f-icon-close"><line x1="18" y1="6" x2="6" y2="18"></line><line x1="6" y1="6" x2="18" y2="18"></line></svg>',
            onClick: (event, el) => {
              this.lightbox.pswp.close();
            },
          });
        });

        this.lightbox.init();

        addEventDelegate({
          selector: this.selectors.toggleZoom[0],
          context: this,
          handler: (e, media) => {
            const mediaContainer = media.closest(".f-product__media");
            const mediaType = mediaContainer
              ? mediaContainer.dataset.mediaType
              : media.dataset.mediaType;
            const mediaIndex =
              Number((mediaContainer || media).dataset.mediaIndex) || 0;

            // Mobile: tapping a product image must NOT open the zoom lightbox
            // (Daniil, 2026-09-15). Shoppers swipe the gallery on a phone and the modal
            // got in the way. Desktop keeps click to zoom, so we block here rather than
            // skipping the lightbox init, leaving the desktop wiring untouched.
            if (FoxThemeSettings.isMobile) {
              e.preventDefault();
              return false;
            }

            const isImage = mediaType === "image";
            if (isImage) {
              // Gymshark-style: open the lightbox on ONLY the tapped image (zoom/pan focus,
              // no swiping between images). Set the dataSource to just this one image, then
              // open index 0. Browsing between images is done in the main gallery.
              const el = mediaContainer || media;
              this.lightbox.options.dataSource = [
                {
                  id: el.dataset.mediaIndex,
                  src: el.dataset.src,
                  width: el.dataset.pswpWidth,
                  height: el.dataset.pswpHeight,
                  mediaType: "image",
                },
              ];
              this.lightbox.loadAndOpen(0);
            }
          },
        });
      }

      onSlideChanged(index) {
        this.draggable = true;
        this.selectedSlide = this.mediaGallery.selectedElement;
        this.selectedMediaType = this.selectedSlide.dataset.mediaType;
        this.selectedMediaId = this.selectedSlide.dataset.mediaId;

        const mediaAspectRatio = this.selectedSlide.dataset.aspectRatio;
        this.domNodes.viewer.style.setProperty(
          "--media-aspect-ratio",
          mediaAspectRatio
        );

        // Zest locks the swipe on media that needs the pointer itself: 3D models, external video
        // and a video with native controls. An autoplay clip has no controls
        // (deferred-media--autoplay, product-thumbnail.liquid), so the swipe must keep working
        // on it (Daniil, 2026-10-10: "I can't swipe to the next image when I am on the video").
        const needsPointer =
          this.selectedMediaType === "model" ||
          this.selectedMediaType === "external_video" ||
          (this.selectedMediaType === "video" &&
            !this.selectedSlide.querySelector(".deferred-media--autoplay"));
        this.toggleDraggable(!needsPointer);

        if (this.selectedMediaType === "model") {
          this.domNodes.xrButton &&
            this.domNodes.xrButton.setAttribute(
              "data-shopify-model3d-id",
              this.selectedMediaId
            );
        }

        if (this.thumbnails) {
          this.thumbnails.select(index);
        }

        if (this.domNodes.sliderCounter) {
          this.domNodes.sliderCounter.textContent = index + 1;
        }

        this.domNodes.mediaGallery.classList.remove("pointer-move");

        this.playActiveMedia(this.selectedSlide);
      }

      handleScreenChange() {
        document.addEventListener("matchMobile", () => {
          this.domNodes.thumbnails.update();
          if (this.thumbnails.cells.length > 4) {
            this.thumbnails.options.wrapAround = true;
            this.domNodes.thumbnails.update();
          }
        });
        document.addEventListener("unmatchMobile", () => {
          this.domNodes.thumbnails.update();
          if (this.thumbnails.cells.length < 6) {
            this.thumbnails.options.wrapAround = false;
            this.domNodes.thumbnails.update();
          }
        });
        if (this.thumbnails.cells.length > 5) {
          this.domNodes.thumbnails.update();
          this.thumbnails.options.wrapAround = true;
          this.domNodes.thumbnails.update();
        }
      }

      toggleDraggable(status = false) {
        this.draggable = status;
        this.mediaGallery.options.draggable = status;
        this.mediaGallery.updateDraggable();
      }

      // K for Kaia: Shopify hosted product videos autoplay muted with no native controls
      // (product-thumbnail.liquid, deferred-media--autoplay). Three rules live here:
      //   1. a clip plays only while at least half of its slide is on screen, pauses when it is
      //      swiped or scrolled away and resumes when it comes back;
      //   2. a tap on the clip, or on the round toggle in its corner, pauses and resumes it, and a
      //      pause the shopper chose sticks until they tap again;
      //   3. the toggle follows the <video> element's real state through its play and pause
      //      events, so it is right whatever started or stopped the clip, including autoplay
      //      being refused (iOS Low Power Mode). prefers-reduced-motion starts every clip paused.
      initGalleryVideos() {
        const wrappers = this.querySelectorAll(".f-product__media--video");
        if (!wrappers.length) return;
        const reduceMotion = window.matchMedia(
          "(prefers-reduced-motion: reduce)"
        ).matches;
        const mayPlay = (wrapper) =>
          wrapper.dataset.inView === "true" &&
          wrapper.dataset.userPaused !== "true";
        const play = (video) => {
          const promise = video.play();
          if (promise && promise.catch) promise.catch(() => {});
        };
        const sync = (video) => {
          const wrapper = video.closest(".f-product__media--video");
          if (!wrapper) return;
          wrapper.classList.toggle("is-playing", !video.paused);
          const toggle = wrapper.querySelector("[data-video-toggle]");
          if (toggle) {
            toggle.setAttribute(
              "aria-label",
              video.paused ? "Play video" : "Pause video"
            );
          }
        };
        const settle = (wrapper) => {
          const video = wrapper.querySelector("video");
          if (!video) return;
          if (mayPlay(wrapper)) {
            if (video.paused) play(video);
          } else if (!video.paused) {
            video.pause();
          }
        };
        const visibleRatio = (wrapper) => {
          const rect = wrapper.getBoundingClientRect();
          if (!rect.width || !rect.height) return 0;
          const w =
            Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);
          const h =
            Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
          return w > 0 && h > 0 ? (w * h) / (rect.width * rect.height) : 0;
        };

        wrappers.forEach((wrapper) => {
          if (reduceMotion) wrapper.dataset.userPaused = "true";
          wrapper.dataset.inView = visibleRatio(wrapper) >= 0.5 ? "true" : "false";
        });

        // 1. in view
        if ("IntersectionObserver" in window) {
          const observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                entry.target.dataset.inView =
                  entry.intersectionRatio >= 0.5 ? "true" : "false";
                settle(entry.target);
              });
            },
            { threshold: [0, 0.5, 1] }
          );
          wrappers.forEach((wrapper) => observer.observe(wrapper));
        }

        // 3. the element is the source of truth; a clip that starts while it should not
        //    (autoplay attribute, loadContent on a slide change) is stopped again
        this.addEventListener(
          "play",
          (event) => {
            const video = event.target;
            if (video.tagName !== "VIDEO") return;
            const wrapper = video.closest(".f-product__media--video");
            if (wrapper && !mayPlay(wrapper)) {
              video.pause();
              return;
            }
            sync(video);
          },
          true
        );
        this.addEventListener(
          "pause",
          (event) => {
            if (event.target.tagName === "VIDEO") sync(event.target);
          },
          true
        );

        // 2. tap to pause or resume; a swipe that starts on the clip is not a tap
        let downX = 0;
        let downY = 0;
        this.addEventListener(
          "pointerdown",
          (event) => {
            downX = event.clientX;
            downY = event.clientY;
          },
          true
        );
        this.addEventListener("click", (event) => {
          const wrapper = event.target.closest(".f-product__media--video");
          if (!wrapper || event.target.closest(".deferred-media__poster")) return;
          if (Math.hypot(event.clientX - downX, event.clientY - downY) > 10) return;
          event.preventDefault();
          const video = wrapper.querySelector("video");
          if (!video) {
            delete wrapper.dataset.userPaused;
            const deferred = wrapper.querySelector("deferred-media");
            if (deferred) deferred.loadContent(false);
            return;
          }
          if (video.paused) {
            delete wrapper.dataset.userPaused;
            play(video);
          } else {
            wrapper.dataset.userPaused = "true";
            video.pause();
          }
        });
      }
      playActiveMedia(selected) {
        window.pauseAllMedia();
        const deferredMedia = selected.querySelector(".deferred-media");
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      setActiveMedia(mediaId) {
        const selectedMedia = this.domNodes.mediaGallery.querySelector(
          `[data-media-id="${mediaId}"]`
        );
        if (!selectedMedia) return;
        const mediaIndex = Number(selectedMedia.dataset.mediaIndex);

        if (this.mediaLayout === "carousel" || FoxThemeSettings.isMobile) {
          this.mediaGallery &&
            this.mediaGallery.select(mediaIndex, false, true);
        } else {
          this.scrollIntoView(selectedMedia);
        }
      }

      scrollIntoView(selectedMedia) {
        if (FoxThemeSettings.isMobile) return;
        selectedMedia.scrollIntoView({
          behavior: "smooth",
        });
      }
    }
  );
}
